// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__zteKc","MenuHidden":"Menu_MenuHidden__K2sgG"};